import { TimePicker as MuiTimePicker } from '@mui/x-date-pickers';

import React, { useState } from 'react';
import { ITimePicker } from './interfaces';

export const TimePicker: React.FC<ITimePicker> = ({
  label,
  selectedTime,
  error,
  errorMessage,
  helperMessage,
  onChange,
  disabled,
  disableFuture,
  disablePast,
  minTime,
  maxTime,
  required,
}): JSX.Element => {
  const [showDialog, setShowDialog] = useState<boolean>(false);

  return (
    <MuiTimePicker
      label={label}
      open={showDialog}
      onClose={() => setShowDialog(false)}
      value={selectedTime}
      onChange={(time) => onChange(time)}
      disabled={disabled}
      ampm={false}
      disableFuture={disableFuture}
      disablePast={disablePast}
      minTime={minTime}
      maxTime={maxTime}
      slotProps={{
        textField: {
          size: 'small',
          fullWidth: true,
          required: required,
          InputProps: {
            readOnly: true,
            onClick: () => setShowDialog(true),
          },
          error: error,
          helperText: error ? errorMessage : helperMessage,
          sx: {
            fontSize: '0.9rem',
            input: {
              fontSize: '0.9rem',
            },
            '& .MuiSvgIcon-root': {
              fontSize: '16px',
            },
          },
        },
      }}
    />
  );
};
